/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type RetryScheduleRequestBody = {
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
  /**
   * Schedule identifier (e.g. cursor, anthropic_compliance, anthropic_analytics_usage).
   */
  schedule: string;
};

/** @internal */
export type RetryScheduleRequestBody$Outbound = {
  provider: string;
  schedule: string;
};

/** @internal */
export const RetryScheduleRequestBody$outboundSchema: z.ZodMiniType<
  RetryScheduleRequestBody$Outbound,
  RetryScheduleRequestBody
> = z.object({
  provider: z.string(),
  schedule: z.string(),
});

export function retryScheduleRequestBodyToJSON(
  retryScheduleRequestBody: RetryScheduleRequestBody,
): string {
  return JSON.stringify(
    RetryScheduleRequestBody$outboundSchema.parse(retryScheduleRequestBody),
  );
}
